document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery !== "undefined" && typeof jQuery.fn.owlCarousel !== "undefined") {
    $('.tastemaker-carousel').owlCarousel({
      loop: false,
      margin: 16,
      nav: false,
      dots: false,
      responsive: {
        0: { items: 2 },
        // 480: { items: 2 },
        768: { items: 3 },
        1024: { items: 4 }
      }
    });
  } else {
    console.warn("jQuery or Owl Carousel is missing.");
  }
});